import { MessageCircle, Mail, ChevronLeft, X } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';
import { supportData } from '../../../../../utils/supportHelpers';
import StatusBadge from '../../TicketList/sections/StatusBadge';

const TicketHeader = ({ selectedTicket }) => {
  const { handleBackToTicketList } = useSupport();

  if (!selectedTicket) return null;

  return (
    <div className="px-4 md:px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-white shadow-sm">
      <div className="flex items-center gap-3">
        <button
          onClick={handleBackToTicketList}
          className="md:hidden p-1 -ml-1 text-gray-500 hover:bg-gray-100 rounded-full cursor-pointer"
        >
          <ChevronLeft size={24} />
        </button>
        <div className="w-10 h-10 bg-[#067978]/10 text-[#067978] rounded-full flex items-center justify-center">
          <MessageCircle size={20} />
        </div>
        <div>
          <h3 className="font-bold text-gray-900 text-sm">
            Case #{selectedTicket._id ? selectedTicket._id.slice(-6).toUpperCase() : ''}
          </h3>
          <div className="flex items-center gap-2">
            <StatusBadge status={selectedTicket.status} />
            <span className="hidden sm:inline text-[10px] text-gray-400 font-medium">
              Trrip Support Desk
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="hidden lg:flex items-center gap-6 text-sm text-gray-600 font-black">
          <a
            href={`mailto:${supportData.supportEmail}`}
            className="flex items-center gap-2 hover:text-[#067978] transition-colors"
          >
            <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center text-[#067978]">
              <Mail size={14} />
            </div>
            {supportData.supportEmail}
          </a>
        </div>
        <button
          onClick={handleBackToTicketList}
          className="hidden md:block p-2 text-gray-400 hover:text-gray-600 cursor-pointer"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default TicketHeader;
